module.exports = __webpack_public_path__ + "img/bg_2.0913b000.png";